<template>
    <div>
        <div v-if="checked">
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary p-0"
                        @click="redirectToList">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>
            <register :registerId="dynamicRegisterEnum.Events"
                      @shouldShowMessage="shouldMessageShow"
                      :entryId="entryId"
                      :isEvent="true"
                      :register-name="'Events'"
                      :annual-catalog-item-id="annualCatalogItemId"
                      :showRelatedForms="showRelatedForms">
            </register>
        </div>

        <div class="clearfix"></div>
    </div>
</template>

<script>
    import Register from '@/components/dynamic/Register';
    import { DynamicRegister } from '@/models/enums';
    import claimsService from '@/services/claims.service';

    export default {
        inject: ['$validator'],
        components: {
            Register
        },
        props: {
            showRelatedForms: {
                default: true,
                type: Boolean
            },
            returnUrl: {
                type: String
            },
        },
        data() {
            return {
                entryId: this.$route.params.id,
                dynamicRegisterEnum: DynamicRegister,
                annualCatalogItemId: null,
                checked: false,
                showMessage: false
            }
        },
        methods: {
            checkClaims() {
                if (this.isNew) {
                    this.checked = true;
                    return;
                }

                claimsService
                    .eventPermission(this.entryId)
                    .then(response => {
                        if (!response.data || !response.data.canEdit) {
                            return this.$router.push(`/unauthorized`);
                        }

                        this.$store.dispatch('setEventReadRights', response.data.canRead);
                        this.$store.dispatch('setEventEditRights', response.data.canEdit);
                        this.$store.dispatch('setEventClaims', response.data.claims);
                        this.checked = true;
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })

                        return this.$router.push(`/unauthorized`);
                    });
            },
            redirectToList() {
                if (this.returnUrl) {
                    this.$router.push({ path: this.returnUrl });
                } else {
                    this.$router.push({ path: '/registers/events' });
                }
            },
            shouldMessageShow(result) {
                this.showMessage = result;
            }
        },
        mounted: function () {
            this.checkClaims();
            this.annualCatalogItemId = this.$route.params.annualCatalogItemId;
        },
        beforeRouteLeave(to, from, next) {
            if (this.showMessage && !this.$store.isEventSaved) {
                const answer = window.confirm(this.$t('notifications.leavePage'))
                if (answer) {
                    this.$store.isEventSaved = false;
                    next()
                } else {
                    next(false)
                }
            } else {
                this.$store.isEventSaved = false;
                next()
            }
        },
        computed: {
            isNew() {
                let num = Number(this.entryId)
                return isNaN(num) || num <= 0;
            },
        },
    }
</script>
